import posthog from "posthog-js";
import { sessionsStream } from "../bytebeamClient";

export const startSession = async (
  sessionID = "default_id",
  deviceID = "default_device_ID",
  userID = "default_user",
  recipeID = "default_ID",
  startTime = Date.now()
) => {
  sessionsStream.publish({ sessionID, deviceID, userID, recipeID, startTime });
  console.log("start session logged");
};

export const endSession = async (
  sessionID = "default_id",
  completionCode = "default_completion_code",
  CookingExperienceRating = "-1",
  foodExperienceRating = "-1",
  endTime = Date.now()
) => {
  console.log("end session logged");
  sessionsStream.publish({
    sessionID,
    completionCode,
    CookingExperienceRating,
    foodExperienceRating,
    endTime,
  });
};

export const logEvents = async (
  sessionID = "default_id",
  eventType = "default_event_type",
  eventData = {},
  timeStamp = Date.now()
) => {
  const data = {
    ...eventData,
    sessionId: sessionID,
    time: timeStamp,
    live: process.env.REACT_APP_VERCEL_ENV === "production",
  }
  posthog.capture(eventType, data)
  console.log("events logged - " + eventType);
};
